export default "__VITE_ASSET__CuizogP9__"